// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import DashboardOutlined from '/app/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
import DatabaseOutlined from '/app/node_modules/@ant-design/icons/es/icons/DatabaseOutlined';
import TeamOutlined from '/app/node_modules/@ant-design/icons/es/icons/TeamOutlined';
import SettingOutlined from '/app/node_modules/@ant-design/icons/es/icons/SettingOutlined';
import ContactsOutlined from '/app/node_modules/@ant-design/icons/es/icons/ContactsOutlined';
import ShoppingOutlined from '/app/node_modules/@ant-design/icons/es/icons/ShoppingOutlined';
import UserOutlined from '/app/node_modules/@ant-design/icons/es/icons/UserOutlined';
import TruckOutlined from '/app/node_modules/@ant-design/icons/es/icons/TruckOutlined';
export default { DashboardOutlined, DatabaseOutlined, TeamOutlined, SettingOutlined, ContactsOutlined, ShoppingOutlined, UserOutlined, TruckOutlined };
